import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { Logo } from "@/components/Logo";
import api from "@/lib/api";

export default function FamilyJoin() {
  const { t } = useApp();
  const nav = useNavigate();
  const [p] = useSearchParams();
  const code = p.get("code") || "";
  const [status, setStatus] = useState("working");

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("sb_token");
      if (!token) { if (code) localStorage.setItem("sb_pending_family", code); nav("/login"); return; }
      try { await api.post("/family/join", { code }); localStorage.removeItem("sb_pending_family"); toast.success(t("joined")); nav("/profile"); }
      catch { setStatus("error"); }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="mx-auto max-w-md min-h-[100dvh] flex flex-col items-center justify-center px-6 gap-4" style={{ background: "var(--app-bg)" }} data-testid="family-join-page">
      <Logo className="h-16" />
      <p className="font-body text-gray-700" data-testid="family-join-status">{status === "error" ? t("resetInvalid") : "…"}</p>
      <button onClick={() => nav("/profile")} className="sb-btn px-5 py-2.5 bg-white font-medium">{t("back")}</button>
    </div>
  );
}
